import { apiSlice } from "./ApiSlice";


const AddDistributorApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    AddDistributor: builder.mutation({
      query: (formData) => {
        return {
          url: "/purchase-InsertorUpdateDistributor",
          method: "POST",
          body: formData,
        };
      },
    }),
  }),
});

export const { useAddDistributorMutation } = AddDistributorApiSlice;
    